import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelEtiquetas(props) {
    return (
        <Fragment><br/>
            <div className='container'>
            <h1>Panel Etiquetas</h1>
            
            </div>



        </Fragment>
    );
};


export default withRouter(PanelEtiquetas)
